import React, { useEffect, useState } from 'react';

const SW_UPDATE_SHOWN_KEY = 'sw_update_shown_version';

const ServiceWorkerUpdateAlert = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => {
      // Verifica se abbiamo già mostrato il banner per questa versione
      const currentVersion = localStorage.getItem('chakur_app_version') || '1.0.0';
      const shownVersion = sessionStorage.getItem(SW_UPDATE_SHOWN_KEY);

      // Mostra il banner solo se non l'abbiamo già mostrato in questa sessione
      if (shownVersion !== currentVersion) {
        setShow(true);
      } else {
        console.log('Banner SW già mostrato per questa versione, skip');
      }
    };

    window.addEventListener('swUpdated', handler);
    return () => window.removeEventListener('swUpdated', handler);
  }, []);

  const handleReload = () => {
    // Memorizza che abbiamo mostrato il banner per questa versione
    const currentVersion = localStorage.getItem('chakur_app_version') || '1.0.0';
    sessionStorage.setItem(SW_UPDATE_SHOWN_KEY, currentVersion);

    if (window.swRegistration && window.swRegistration.waiting) {
      window.swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    } else {
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    // Memorizza che abbiamo chiuso il banner per questa versione
    const currentVersion = localStorage.getItem('chakur_app_version') || '1.0.0';
    sessionStorage.setItem(SW_UPDATE_SHOWN_KEY, currentVersion);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 30, left: 0, right: 0, zIndex: 9999,
      background: '#1976d2', color: '#fff', padding: '16px 32px', textAlign: 'center',
      borderRadius: 8, margin: '0 auto', maxWidth: 400, boxShadow: '0 4px 24px #0002',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12
    }}>
      <span>Nuova versione disponibile!</span>
      <button
        style={{ background: '#fff', color: '#1976d2', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer', fontWeight: 600 }}
        onClick={handleReload}
      >
        Aggiorna
      </button>
      <button
        style={{ background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.5)', borderRadius: 4, padding: '4px 8px', cursor: 'pointer', fontSize: 12 }}
        onClick={handleDismiss}
      >
        ✕
      </button>
    </div>
  );
};

export default ServiceWorkerUpdateAlert;

